import { HTMLAttributes } from 'react';

interface MainContentFilterProps extends HTMLAttributes<HTMLParagraphElement> {
    children?: React.ReactNode;
}

function MainContentFilter({ children, ...props }: MainContentFilterProps) {
    return (
        <div className="main__content-filter" {...props}>
            {children}
        </div>
    );
}

export default MainContentFilter;
